module.exports = __webpack_public_path__ + "img/img_web_main.9b5c71ae.jpg";